export default {
    companies: [],
    company: {}
  }